import { ParsedRecord } from 'src/components/import/ImportParser';
import { CreatePjmRegistrationDto } from '../dto/PjmRegistrationDto';
import { PjmRegistrationCsvColumns } from './pjmRegistrationParser';
import { PjmLocationDto } from '../dto/PjmLocationDto';

export function mapCsvImportRegistrationToCreateRegistrationDto(
    record: ParsedRecord<PjmRegistrationCsvColumns>,
    location: PjmLocationDto
): CreatePjmRegistrationDto {
    const dto = {} as CreatePjmRegistrationDto;
    dto.locationUuid = location.uuid;

    dto.summaryInfo = {
        name: record['Registration Name*'].parsedValue,
        program: record['Program*'].parsedValue,
        startDate: record['Effective Date (MM/DD/YYYY)*'].parsedValue,
        endDate: record['Termination Date (MM/DD/YYYY)*'].parsedValue,

        /** bellow values are copied from location */
        CSP: {
            name: location.summaryInfo.CSP.name,
        },
        EDC: {
            name: location.summaryInfo.EDC.name,
            accountNo: location.summaryInfo.EDC.accountNo,
        },
        zone: location.summaryInfo.zone,
        pricingPoint: location.summaryInfo.pricingPoint,

        residential: record['Residential Registration (Yes/No)'].parsedValue,
        residentialProgramType: record['Residential Program Type'].parsedValue,
        loadDataSample: record['Load Data Sample (Yes/No)'].parsedValue,
        sampleNumberParticipants: record['# Sample Participants'].parsedValue,
    };

    if (location.profileInfo) {
        dto.locationSummaryInfo = {
            // copy from location
            energyLossFactor: location.profileInfo.energyLossFactor,
            capacityLossFactor: location.profileInfo.capacityLossFactor,
            peakLoadContribution: location.profileInfo.peakLoadContribution,
            winterPeakLoad: location.profileInfo.winterPeakLoad,
            maximumLoadReductionCapability: location.profileInfo.loadReduction,
        };
    }

    dto.capacityInfo = {
        capacityType: undefined,
        zoneArea: undefined,
        RPMResourceID: record['RPM DR Resource ID'].parsedValue,
        measurementMethod: record['Measurement Method'].parsedValue,
        capacityLossFactor: location.profileInfo?.capacityLossFactor,
        peakLoadContribution: location.profileInfo?.peakLoadContribution,
        winterPeakLoad: undefined,
        summerManagedLoad: record['Summer Managed Load (kW)'].parsedValue,
        winterManagedLoad: record['Winter Managed Load (kW)'].parsedValue,
        summerWeatherAdjustmentFactor: undefined,
        winterWeatherAdjustmentFactor: undefined,
        participantCount: undefined,
        summerNominatedICAP: undefined,
        winterNominatedICAP: undefined,
        annualNominatedICAP: undefined,
        product: record['Product'].parsedValue,
        resourceType: record['Resource Type'].parsedValue,
        leadTime: record['Lead Time*'].parsedValue,
        leadExceptionCertify: record['Lead Exception Documentation (Yes/No)'].parsedValue,
        leadExceptionReason: record['Lead Exception Reason'].parsedValue,
        leadExceptionDesc: record['Lead Exception Description'].parsedValue,
        summerOnly: record['Summer Only (Yes/No)*'].parsedValue,
    };

    dto.energyInfo = {
        loadReduction: undefined,
        energyLossFactor: undefined,
        strikePrice: record['Strike Price (US$)'].parsedValue,
        shutdownCosts: record['Shutdown Cost (US$)'].parsedValue,
        contractType: undefined,
        priceNode: undefined,
        retailRate: undefined,
        rateName: undefined,
        rateDescription: undefined,
        dayAhead: undefined,
        realTime: undefined,
        scheduledReserve: undefined,
        secondaryReserve: undefined,
        synchronizedReserve: undefined,
        flexible: undefined,
        inflexible: undefined,
        regulation: undefined,
        batchLoad: undefined,
        secrArea: undefined,
        secrSCADATestedAndVerified: undefined,
        srArea: undefined,
        srSCADATestedAndVerified: undefined,
        regulationSCADAName: undefined,
        regulationSCADATestedAndVerified: undefined,
        regulationTestCompleted: undefined,
        submeter: undefined,
        regulationCertify: undefined,
    };

    dto.otherInfo = {
        allowEDCtoModify: record['Allow Modification EDC (Yes/No)*'].parsedValue,
        allowLSEtoModify: record['Allow Modification LSE (Yes/No)*'].parsedValue,
    };

    return dto;
}
